import '@css/main.scss'
import '@js/bootstrap'

import {Header} from '@js/components/Header'
import {Timeline} from '@js/components/Timeline'
import {Slider} from '@js/components/Slider'
import {AccessMap} from '@js/components/AccessMap'
import {Archive} from '@js/components/Archive'
import {Mask} from '@js/animations/Mask'
import {Stagger} from '@js/animations/Stagger'
import {Wipe} from '@js/animations/Wipe'
import {Scroll} from '@js/animations/Scroll'
import {Translate} from '@js/animations/Translate'
import {Shape} from '@js/animations/Shape'
import {Zoom} from '@js/animations/Zoom'

import {Reveal} from '@js/animations/Reveal'

new Reveal()

new Header()

window.onload = () => {

  const animations = [
    Mask,
    Stagger,
    Wipe,
    Scroll,
    Translate,
    Shape,
    Zoom
  ]

  animations.forEach(animation => {
    new animation()
  })

  new Timeline()
  new Archive()
  new Slider()
  new AccessMap()

}
